import { render, staticRenderFns } from "./shangqingalarm.vue?vue&type=template&id=5e346f69&"
import script from "./shangqingalarm.vue?vue&type=script&lang=js&"
export * from "./shangqingalarm.vue?vue&type=script&lang=js&"
import style0 from "./shangqingalarm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports